import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.header}>Paramètres de Confidentialité de AUNE</h1>
            <p style={styles.paragraph}>Bienvenue dans les Paramètres de Confidentialité de AUNE. Nous prenons très au sérieux la protection de vos données personnelles et nous nous engageons à garantir que vos informations soient traitées avec le plus grand soin et respect. Cette page vous permet de gérer les paramètres de confidentialité de votre compte pour assurer une utilisation en toute confiance de notre plateforme.</p>

            <h2 style={styles.subHeader}>1. Gestion des Données Personnelles</h2>
            <h3 style={styles.subSubHeader}>1.1. Profil Public vs Privé :</h3>
            <p style={styles.paragraph}><strong>Public :</strong> Votre profil et vos vidéos sont visibles par tous les utilisateurs de la plateforme. Cela inclut votre nom, votre photo de profil, vos descriptions de vidéos et toute autre information publique que vous choisissez de partager.</p>
            <p style={styles.paragraph}><strong>Privé :</strong> Seuls vos abonnés approuvés peuvent voir votre profil et vos vidéos. Les informations sensibles telles que votre adresse e-mail et votre numéro de téléphone restent toujours confidentielles et ne sont jamais partagées sans votre consentement explicite.</p>

            <h3 style={styles.subSubHeader}>1.2. Contrôle des Informations Partagées :</h3>
            <p style={styles.paragraph}><strong>Informations de Contact :</strong> Vous pouvez choisir de rendre votre adresse e-mail et votre numéro de téléphone visibles à vos contacts approuvés ou de les garder totalement privés.</p>
            <p style={styles.paragraph}><strong>Biographie et Réalisations :</strong> Vous pouvez éditer ou masquer certaines sections de votre profil, telles que votre biographie, vos compétences et vos réalisations professionnelles.</p>

            <h2 style={styles.subHeader}>2. Paramètres de Partage de Contenu</h2>
            <h3 style={styles.subSubHeader}>2.1. Visibilité des Vidéos :</h3>
            <p style={styles.paragraph}><strong>Public :</strong> Les vidéos que vous publiez peuvent être vues par tous les utilisateurs de AUNE.</p>
            <p style={styles.paragraph}><strong>Privé :</strong> Les vidéos que vous publiez ne sont visibles que par vous et les utilisateurs que vous choisissez explicitement.</p>
            <p style={styles.paragraph}><strong>Personnalisé :</strong> Vous pouvez définir des listes spécifiques de contacts qui peuvent voir chaque vidéo que vous publiez.</p>

            <h3 style={styles.subSubHeader}>2.2. Commentaires et Interactions :</h3>
            <p style={styles.paragraph}><strong>Commentaires :</strong> Vous pouvez choisir de permettre ou de désactiver les commentaires sur vos vidéos. Vous pouvez également approuver les commentaires avant qu'ils ne soient visibles par d'autres utilisateurs.</p>
            <p style={styles.paragraph}><strong>Mentions J’aime et Partages :</strong> Vous pouvez autoriser ou restreindre les mentions J’aime et les partages de vos vidéos.</p>

            <h2 style={styles.subHeader}>3. Notifications et Communications</h2>
            <h3 style={styles.subSubHeader}>3.1. Notifications :</h3>
            <p style={styles.paragraph}><strong>Personnalisation des Notifications :</strong> Vous pouvez sélectionner les types de notifications que vous souhaitez recevoir, telles que les mentions J’aime, les commentaires, les nouveaux abonnés, ou les suggestions de contenu.</p>
            <p style={styles.paragraph}><strong>Fréquence des Notifications :</strong> Vous pouvez choisir de recevoir des notifications en temps réel, de manière quotidienne, hebdomadaire ou de ne pas recevoir de notifications du tout.</p>

            <h3 style={styles.subSubHeader}>3.2. Communications de Marketing :</h3>
            <p style={styles.paragraph}><strong>Opt-in/Opt-out :</strong> Vous avez la possibilité de vous inscrire ou de vous désinscrire des communications de marketing et des newsletters. Vous pouvez modifier ces préférences à tout moment dans les paramètres de votre compte.</p>

            <h2 style={styles.subHeader}>4. Sécurité et Authentification</h2>
            <h3 style={styles.subSubHeader}>4.1. Authentification à Deux Facteurs (2FA) :</h3>
            <p style={styles.paragraph}><strong>Activation du 2FA :</strong> Pour renforcer la sécurité de votre compte, nous recommandons l’activation de l’authentification à deux facteurs. Cela ajoute une couche supplémentaire de protection en demandant une vérification via votre téléphone mobile en plus de votre mot de passe.</p>

            <h3 style={styles.subSubHeader}>4.2. Gestion des Sessions Actives :</h3>
            <p style={styles.paragraph}><strong>Vue d’Ensemble des Sessions :</strong> Vous pouvez voir toutes les sessions actives de votre compte et les appareils connectés. Vous avez la possibilité de déconnecter des appareils spécifiques ou de terminer toutes les sessions actives.</p>

            <h2 style={styles.subHeader}>5. Accès aux Données et Suppression du Compte</h2>
            <h3 style={styles.subSubHeader}>5.1. Exportation de Données :</h3>
            <p style={styles.paragraph}><strong>Téléchargement de Vos Données :</strong> Vous pouvez demander une copie de toutes les données personnelles que nous détenons à votre sujet. Ces données peuvent être téléchargées au format JSON ou CSV.</p>

            <h3 style={styles.subSubHeader}>5.2. Suppression du Compte :</h3>
            <p style={styles.paragraph}><strong>Demande de Suppression :</strong> Si vous souhaitez supprimer votre compte, vous pouvez en faire la demande via les paramètres de confidentialité. Cette action est irréversible et entraînera la suppression permanente de toutes vos données et contenus associés.</p>

            <h2 style={styles.subHeader}>6. Contact et Assistance</h2>
            <p style={styles.paragraph}>Si vous avez des questions ou des préoccupations concernant vos paramètres de confidentialité, n'hésitez pas à nous contacter à l'adresse <a href="mailto:support@auneapp.com" style={styles.link}>support@auneapp.com</a>. Notre équipe de support est là pour vous aider et répondre à toutes vos interrogations.</p>
            <p style={styles.paragraph}>Nous vous remercions de faire confiance à AUNE pour partager vos vidéos professionnelles et nous nous engageons à protéger vos informations avec le plus grand soin.</p>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        padding: '40px',
        maxWidth: '900px',
        margin: '0 auto',
        lineHeight: '1.8',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        color: '#333',
    },
    header: {
        fontSize: '2.5rem',
        color: '#007bff',
        marginBottom: '20px',
    },
    subHeader: {
        fontSize: '1.8rem',
        color: '#333',
        marginTop: '30px',
        marginBottom: '10px',
        borderBottom: '2px solid #007bff',
        paddingBottom: '5px',
    },
    subSubHeader: {
        fontSize: '1.5rem',
        color: '#555',
        marginTop: '20px',
        marginBottom: '10px',
    },
    paragraph: {
        fontSize: '1rem',
        color: '#555',
        marginBottom: '15px',
    },
    link: {
        color: '#007bff',
        textDecoration: 'none',
    }
};

export default PrivacyPolicy;
